import $ from 'jquery'
import Client from '../Client'
import printLogotype from '../../img/logotype-print.png'

/**
 * Tool UI class
 * @param {Object} config
 * @constructor
 */
export default class Tool {
  constructor(config) {
    $.extend(this, config || {})
    this.html = `
    <div id="olga-container" class="olga">
      <div id="image-viewer"></div>

      <nav class="navbar navbar-map navbar-north" role="navigation" id="navbarNorth">
          <div class="container-fluid">
              <a class="navbar-link navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse-north" id="xs-button"><i class="fa fa-bars"></i><span>Navigation</span></a>
              <div class="logotype">
                  <a class="text-hide">
                    <img src="${printLogotype}" alt="" class="visible-print">
                  </a>
              </div>
              <div class="version">${Client.version}</div>
              <div class="customheader hide">
                <div class="title"></div>
                <div class="subtitle"></div>
              </div>
              <nav class="navbar-collapse navbar-collapse-north collapse">
                  <div class="navbar-left pull-left">
                      <ul class="nav navbar-nav">
                      </ul>
                  </div>
                  <div class="navbar-right pull-right">
                    <div class="btn-group">
                      <ul class="nav navbar-nav" id="navbarNorthButtons">
                          ${
                            this.config.print
                              ? '<li><a id="print-toggle-button" data-target="#print-settings-modal" data-toggle="modal"><i class="fa fa-print"></i> <span>Skriv ut</span></a></li>'
                              : ''
                          }
                      </ul>
                    </div>
                  </div>
              </nav>
          </div>
      </nav>

      <div id="map"></div>

      <nav class="navbar navbar-map navbar-south" role="navigation" id="navbarSouth">
          <div class="container-fluid">
              <nav>
                  <div class="pull-left mapping">
                      <div class="btn-group dropup" id="tools-dropup">
                          <button class="link-navbar dropdown-toggle" type="button" data-toggle="dropdown">
                              <i class="map-navigate"></i>Verktyg<b class="caret"></b>
                          </button>
                          <ul class="dropdown-menu">
                              <li class="dropdown-header">Kartverktyg</li>
                              <li><a id="toolsDisable"><i class="map-navigate"></i> Navigera & visa info</a></li>
                              <li><a id="lineToggle"><i class="map-measure"></i> M&auml;t l&auml;ngd</a></li>
                              <li><a id="polygonToggle"><i class="map-measure-area"></i> M&auml;t yta</a></li>
                              <li><a id="coordinate"><i class="fa fa-map-marker"></i> Koordinat</a></li>
                              <li class="divider digitizing hide"></li>
                          </ul>
                          <button class="link-navbar hide" type="button" id="selectClearAll">
                              <i class="fa fa-eraser"></i>Rensa markering <span class="badge"></span>
                          </button>
                      </div>
                  </div>
                  <div class="pull-right">
                    <span class="ui-buttons" style="float:left" ></span>
                    <ul class="nav navbar-nav">
                      <li>
                        <button id="layers-toggle-button" class="link-navbar open-right-sidr" type="button" data-toggle="dropdown"><i class="fa fa-bars"></i> Kartlager</button>
                      </li>
                    </ul>
                  </div>
              </nav>
          </div>
      </nav>

      <div id="text-tool-popover" class="popover top in" style="display:none;">
          <div class="arrow"></div>
          <a class="close popover-close"><i class="fa fa-times-circle icon-only"></i></a>
          <h3 class="popover-title">Skriv text</h3>
          <div class="popover-content">
              <fieldset class="form-horizontal">
                  <div class="form-group">
                      <input type="text" class="form-control input-sm" id="edit-text" placeholder="Text">
                  </div>
              </fieldset>
          </div>
          <div class="popover-footer">
              <div class="btn-toolbar">
                  <button type="button" class="btn btn-default btn-sm" id="edit-text-delete">Ta bort</button>
                  <button type="button" class="btn btn-primary btn-sm" id="edit-text-submit">Placera</button>
              </div>
          </div>
      </div>

      <div id="delete-tool-popover" class="popover top in" style="display:none;with: auto;min-width:160px;">
          <div class="arrow"></div>
          <div class="popover-content"></div>
          <div class="popover-footer">
              <div class="btn-toolbar">
                  <button type="button" class="btn btn-primary btn-sm" id="delete-confirm">Ta bort</button>
                  <button type="button" class="btn btn-default btn-sm" id="delete-cancel">Avbryt</button>
              </div>
          </div>
      </div>

      <div id="identify-properties" class="popover top in">
          <div class="arrow"></div>
          <a class="close popover-close"><i class="fa fa-times-circle icon-only"></i></a>
          <h3 class="popover-title"></h3>
          <div class="popover-content">
          </div>
          <div class="popover-footer">
          </div>
      </div>

      <aside id="sidr-right" class="sidr right" style="transform: translate(12px,0px)">
          <div class="container-fluid">
              <div class="row">
                  <div class="col-md-12 layerlist" id="toc-container">
                      <div class="layerlist-header">
                          <h5>Kartlager</h5>
                          <h6 id="collapse-layerlist"><a >Teckenf&ouml;rklaringar<i class="fa fa-bars"></i></a></h6>
                      </div>
                      <div id="toc-layers"></div>
                  </div>
              </div>
          </div>
      </aside>

      <div class="sidr-backdrop in hide"></div>

      <div class="modal fade" id="print-settings-modal" tabindex="-1" role="dialog" aria-labelledby="printSettingsModalLabel" aria-hidden="true">
          <div class="modal-dialog">
              <div class="modal-content">
                  <div class="modal-header">
                      <button type="button" class="close print-cancel-button" data-dismiss="modal" aria-hidden="true"><i class="fa fa-times-circle icon-only"></i></button>
                      <h4 class="modal-title" id="myModalLabel">Skriv ut</h4>
                  </div>
                  <div class="modal-body">
                      <fieldset class="form-horizontal">
                          <div class="form-group">

                              <label for="print-title" class="col-xs-3 control-label">Rubrik</label>
                              <div class="col-xs-9">
                                 <input type="text" class="form-control" id="print-title" placeholder="Rubrik p&aring; utskrift">
                              </div>

                          </div>
                      </fieldset>
                  </div>
                  <div class="modal-footer">
                      <button type="button" class="btn btn-default print-cancel-button" data-dismiss="modal">Avbryt</button>
                      <button type="button" class="btn btn-primary" id="print-map-preview">Förhandsgranska</button>

                      <!-- <button type="button" class="btn btn-primary" id="print-map">Skriv ut till PDF</button> -->
                  </div>
              </div>
          </div>
      </div>

      <div class="ol-gps">
          <button id="gpsToggle" class="ol-gps-button"><i class="fa fa-crosshairs icon-only"></i></button>
      </div>
      <i id="gps-icon" style="display: none;" class="fa fa-crosshairs icon-only"></i>

      <div id="print-preview-toolbar" style="display:none;">
          <button type="button" class="btn btn-default" id="print-preview-toolbar-cancel">Stäng</button>
          <button type="button" class="btn btn-primary" id="print-preview-toolbar-confirm">Skriv ut</button>
      </div>
    </div>
    <div id="application-container"></div>  

    <div id="spinner-wrapper"></div>
    `
  }

  

  render() {
    const olga = $.parseHTML(this.html)
    const target = this.config.target || document.body
    
    $(target).append(olga)
  }
}
